import img1 from '../../assets/img/kappa.jpg';

const aboutTwoData = {
    img: img1,
    heading: 'ProtoPath is committed to delivering exceptional engineering solutions.',
    quote: 'Transforming innovative concepts into precision-engineered reality through expert rapid prototyping and manufacturing excellence.',
    author: 'ProtoPath Team',
    position: '- Engineering Specialists',
    text: 'With extensive experience in CAD design, 3D scanning, and manufacturing consulting, ProtoPath delivers comprehensive solutions from initial concept through to production. Our expertise in ISO conformance and production optimisation ensures your projects meet the highest standards of quality and efficiency.',
};

export default aboutTwoData;
